import Tabs from "@/components/Tabs";
import KbvBangKeo from "../BangKeo";
import { BangXepHangPage } from "@/components/BangXepHang";
import KbvTiLe from "../KbvTiLe";
import LichThiDau from "../LichThiDau";
import { useCompConfig } from "@/context/CompConfigContext";

const KeoBongVipPlugin = () => {
  const { colorPrimary, colorSecondary, colorBg, colorText, colorForeground, hasDataConfig } = useCompConfig();
  return (
    <div
      className="keobongvip-root"
      style={
        hasDataConfig
          ? {
              "--theme-primary": colorPrimary,
              "--theme-highlight": colorSecondary,
              "--theme-bg": colorBg,
              "--theme-text": colorText,
              "--theme-foreground": colorForeground,
            }
          : undefined
      }
    >
      <Tabs
        tabs={[
          // { id: "all", label: "Bảng Kèo", children: <KbvBangKeo /> },
          { id: "home", label: "Bảng Kèo", children: <KbvTiLe /> },
          { id: "ket-qua", label: "Kết Quả", children: <KbvBangKeo type="ketqua" /> },
          { id: "bang-xep-hang", label: "Bảng Xếp Hạng", children: <BangXepHangPage /> },
          { id: "lich-thi-dau", label: "Lịch Thi Đấu", children: <LichThiDau /> },
        ]}
        defaultTab="home"
        onChange={(id) => console.log(id)}
      />
    </div>
  );
};

export default KeoBongVipPlugin;